/**
 * Конфигурация доменов и их особенностей
 * Каждый домен может иметь свои настройки тарифов, локализации и функционала
 */

export const DOMAIN_CONFIGS = {
  // Основной домен
  'fithousse.com': {
    name: 'FitHousse',
    locale: 'ru',
    currency: 'RUB',
    features: {
      pricing: true,
      aiCoach: true,
      nutrition: true,
      community: true,
      challenges: true,
      analytics: true,
    },
    branding: {
      logo: 'FITHOUSSE',
      tagline: 'Твоя сила. Твои правила. Твой результат.',
      domain: 'fithousse.com',
      colors: {
        primary: '#ff6b35',
        secondary: '#004e89',
      },
    },
    contact: {
      email: 'support@fithousse.com',
      phone: '+7 (xxx) xxx-xx-xx',
    },
    socials: {
      instagram: '#',
      youtube: '#',
      telegram: '#',
      vk: '#',
    },
  },

  // Узбекский поддомен
  'uzm.fithousse.com': {
    name: 'FitHousse Uzbekistan',
    locale: 'uz',
    currency: 'UZS',
    features: {
      pricing: false, // Отключены тарифы
      aiCoach: true,
      nutrition: true,
      community: true,
      challenges: false, // Отключены челленджи
      analytics: true,
    },
    branding: {
      logo: 'FITHOUSSE',
      tagline: 'Sizning kuchingiz. Sizning qoidalaringiz. Sizning natijangiz.',
      domain: 'uzm.fithousse.com',
      colors: {
        primary: '#ff6b35',
        secondary: '#004e89',
      },
    },
    contact: {
      email: 'support.uz@fithousse.com',
      phone: '+998 (xx) xxx-xx-xx',
    },
    socials: {
      instagram: '#',
      youtube: '#',
      telegram: '#',
      vk: null, // VK не используется в Узбекистане
    },
  },

  // Конфигурация по умолчанию (для localhost и неизвестных доменов)
  'default': {
    name: 'FitHousse',
    locale: 'ru',
    currency: 'RUB',
    features: {
      pricing: true,
      aiCoach: true,
      nutrition: true,
      community: true,
      challenges: true,
      analytics: true,
    },
    branding: {
      logo: 'FITHOUSSE',
      tagline: 'Твоя сила. Твои правила. Твой результат.',
      domain: 'fithousse.com',
      colors: {
        primary: '#ff6b35',
        secondary: '#004e89',
      },
    },
    contact: {
      email: 'support@fithousse.com',
      phone: '+7 (xxx) xxx-xx-xx',
    },
    socials: {
      instagram: '#',
      youtube: '#',
      telegram: '#',
      vk: '#',
    },
  },
};

/**
 * Получить текущий домен (без www)
 */
export const getCurrentDomain = () => {
  if (typeof window === 'undefined') {
    return 'default';
  }

  const hostname = window.location.hostname;
  // Убираем www. если есть
  return hostname.replace(/^www\./, '');
};

/**
 * Получить конфигурацию для текущего домена
 */
export const getDomainConfig = () => {
  const domain = getCurrentDomain();
  return DOMAIN_CONFIGS[domain] || DOMAIN_CONFIGS['default'];
};

/**
 * Проверить, включена ли определенная функция
 */
export const isFeatureEnabled = (featureName) => {
  const config = getDomainConfig();
  return config.features[featureName] === true;
};

/**
 * Получить настройки брендинга
 */
export const getBranding = () => {
  const config = getDomainConfig();
  return config.branding;
};

/**
 * Получить локаль текущего домена
 */
export const getLocale = () => {
  const config = getDomainConfig();
  return config.locale;
};

/**
 * Получить валюту текущего домена
 */
export const getCurrency = () => {
  const config = getDomainConfig();
  return config.currency;
};

/**
 * Получить контактную информацию
 */
export const getContactInfo = () => {
  const config = getDomainConfig();
  return config.contact;
};

/**
 * Получить социальные сети (только активные)
 */
export const getSocialLinks = () => {
  const config = getDomainConfig();
  return Object.entries(config.socials)
    .filter(([, url]) => url !== null)
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
};

/**
 * Проверить, является ли текущий домен определенным
 */
export const isDomain = (domainName) => {
  const currentDomain = getCurrentDomain();
  return currentDomain === domainName;
};
